import workersApi from '@/api/workers';

const state = {
  allworkers: [],
  activeWorkers: [],
  workers: [],
  worker: {},
};

export const getters = {
  formattedWorkers: state =>
    state.workers.map(worker => ({
      label: `${worker.lastName}, ${worker.firstName}`,
      value: worker.workerGuid,
    })),

    formattedActiveWorkers: state =>
    state.activeWorkers.map(worker => ({
      label: `${worker.lastName}, ${worker.firstName}`,
      value: worker.workerGuid,
    })),
    
  formattedWorker: state => (workerGuid) => {
    let name = '';
    for (let i = 0; i < state.workers.length; i += 1) {
      if (workerGuid === state.workers[i].workerGuid) {
        // eslint-disable-next-line
        name = state.workers[i].lastName + ', ' + state.workers[i].firstName;
      }
    }
    return name;
  },
  formattedActiveWorker: state => (workerGuid) => {
    let name = '';
    for (let i = 0; i < state.activeWorkers.length; i += 1) {
      if (workerGuid === state.activeWorkers[i].workerGuid) {
        // eslint-disable-next-line
        name = state.activeWorkers[i].lastName + ', ' + state.activeWorkers[i].firstName;
      }
    }
    return name;
  },
};

export const actions = {
  getList({ commit }) {
    workersApi.getWorkers().then((data) => {
      commit('workers', data.workers);
    });
  },
  getActiveList({ commit }) {
    workersApi.getAllActiveWorkers().then((data) => {
      commit('activeWorkers', data.workers);
    });
  },
  get({ commit }, arg) {
    workersApi.getWorker(arg).then((data) => {
      commit('worker', data.worker);
    });
  },

  search({ commit }, arg) {
    workersApi.searchWorker(arg).then((data) => {
      commit('workers', data.workers);
    });
  },

  save({ commit }, args) {
    workersApi.saveWorker(args.worker).then((data) => {
      commit('workers', data.workers);
      commit(
        'alert/add',
        {
          title: 'Informations',
          message: 'L\'individu été modifié avec succès!',
          variant: 'success',
          icon: 'check_circle',
        },
        { root: true },
      );
      commit('worker', {});
    });
  },

  delete({ dispatch }, args) {
    workersApi.deleteWorker(args).then(() => {
      dispatch('getList');
    });
  },

};
export const mutations = {
  activeWorkers(state, payload) {
    state.activeWorkers = payload;
  },
  workers(state, payload) {
    state.workers = payload;
  },
  worker(state, payload) {
    state.worker = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
